export default __webpack_public_path__ + "static/media/banner-bg-1-1.5e308ce6.png";